export default __webpack_public_path__ + "static/media/K_wdt_c_cap_2.7c393d5d.mp3";